import React from "react";
import {Route, Switch, Redirect} from "react-router-dom";
import {appContainer, Subscribe} from "../../contexts/app";
import {MarkerTypeRecord} from "../../feathers/records";
import MarkerTypePanel from "../../components/MarkerTypePanel";
import {PanelContainer} from "../../components/Panel";
import PageContainer from "../../components/PageContainer";
import {getPlaceInfo} from "../../components/Utilities";
import "./style.scss";

class MarkerTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      panelOpen: true,
      markerTypes: this.props.markerTypes
    };
  }

  handlePanelToggle = () => {
    this.setState({panelOpen: !this.state.panelOpen});
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      markerTypes: nextProps.markerTypes,
      markerTypeCategories: nextProps.markerTypeCategories
    });
  }

  handleRedirect(props) {
    // We need to ensure id's exist at each path endpoint
    // If not, this is either an invalid id or it has been deleted
    const {path, params} = props.match;
    let redirect = null;
    if (path === "/marker-types/:markerTypeId" && !props.markerTypes.has(params.markerTypeId)) {
      redirect = `/marker-types`;
    }
    return redirect;
  }

  render() {
    const redirect = this.handleRedirect(this.props);
    if (redirect) {
      return <Redirect to={redirect} />;
    }
    const {match, markerTypeCategories} = this.props;
    const categoryOptions = markerTypeCategories.toList().map(category => ({value: category._id, text: category.name}));

    const {markerTypeId} = match.params;
    const {markerTypes} = this.state;
    return (
      <PageContainer {...this.props} editMode={false}>
        <div className="blurBGPage">
          <Switch>
            <Route
              exact
              path="/marker-types"
              render={() => {
                const markerType = new MarkerTypeRecord();
                return (
                  <PanelContainer
                    id="markerTypeForm"
                    width={475}
                    open={this.state.panelOpen}
                    onToggle={this.handlePanelToggle}>
                    <MarkerTypePanel markerType={markerType} categoryOptions={categoryOptions} />
                  </PanelContainer>
                );
              }}
            />
            <Route
              exact
              path="/marker-types/:markerTypeId"
              render={() => {
                const markerType = markerTypes.get(markerTypeId);
                return (
                  <PanelContainer
                    id="markerTypeForm"
                    width={475}
                    open={this.state.panelOpen}
                    onToggle={this.handlePanelToggle}>
                    <MarkerTypePanel markerType={markerType} categoryOptions={categoryOptions} key={markerType._id} />
                  </PanelContainer>
                );
              }}
            />
          </Switch>
        </div>
      </PageContainer>
    );
  }
}

export default routeProps => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        const placeInfo = getPlaceInfo(app, routeProps.location.query);
        const sidebarOpen = app.state.get("sidebarOpen");
        return (
          <React.Fragment>
            <MarkerTypes
              {...routeProps}
              {...placeInfo}
              markerTypeCategories={app.state.get("markerTypeCategories")}
              markerTypes={app.state.get("markerTypes")}
              sidebarOpen={sidebarOpen}
            />
          </React.Fragment>
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/MarkerTypes/index.jsx